import { render, staticRenderFns } from "./ShareMessageModal.vue?vue&type=template&id=3da37610"
import script from "./ShareMessageModal.vue?vue&type=script&lang=js"
export * from "./ShareMessageModal.vue?vue&type=script&lang=js"
import style0 from "./ShareMessageModal.vue?vue&type=style&index=0&id=3da37610&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports